import { HttpStatus, StatusError } from '../types/status';

export const statusFromCode = (code: number) => {
	const found = Object.entries(HttpStatus).find(([, value]) => value === code)?.[0];

	if (!found) {
		return 'Unknown';
	}

	// Special case for the OK status
	if (found === 'OK') {
		return found;
	}

	return found.replace(/([A-Z])/g, ' $1').trim();
};

export const isStatusError = (object: unknown): object is StatusError => {
	return typeof object === 'object' && !!object && 'status' in object && typeof object.status === 'number';
};
